import { render, staticRenderFns } from "./GPPDashboard.vue?vue&type=template&id=c25fca6a"
import script from "./GPPDashboard.vue?vue&type=script&lang=js"
export * from "./GPPDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports